import type { IconDefinition } from '../index.tsx';

export const iconCalendarXmark: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCalendarXmark',
  icon: [
    16,
    16,
    [],
    '',
    'M3 0H6V2H10V0H13V2H15V5H1V2H3V0ZM1 7H15V15H1V7ZM6.95312 11.0259L5.48438 9.55713C5.17188 9.24463 5.17188 8.77588 5.48438 8.49463C5.76562 8.18213 6.23438 8.18213 6.51562 8.49463L8.01562 9.99463L9.48438 8.52588C9.76562 8.21338 10.2344 8.21338 10.5156 8.52588C10.8281 8.80713 10.8281 9.27588 10.5156 9.58838L9.04688 11.0259L10.5156 12.5259C10.8281 12.8071 10.8281 13.2759 10.5156 13.5571C10.2344 13.8696 9.76562 13.8696 9.45312 13.5571L8.01562 12.0884L6.51562 13.5571C6.23438 13.8696 5.76562 13.8696 5.48438 13.5571C5.17188 13.2759 5.17188 12.8071 5.48438 12.4946L6.95312 11.0259Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
